import { LiquidacionCapturaService } from './../../../services/liquidacion-captura.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import {ObrasService} from "../../../services/obras.service";
import {HelpersService} from "../../../services/tools/helpers.service";
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
declare var $;

@Component({
  selector: 'app-liquidacion-modal',
  templateUrl: './liquidaciones-modal.component.html',
  styleUrls: ['./liquidaciones-modal.component.scss']
})
export class LiquidacionModalComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  cuentasSelectedOptions: any = [];


  obrasOptions : any = [];
  obraFilter: any = {};
  obraFilterOptions: any[];
  fechaActual: string;
  año:any;
  mes:string;
  dia:string;
  nuevoMes: any;
  auxMes:any;
  meses: string;
  fechaLiquidacion:string;
  desdeMovimientos:boolean;
  public anyoActual: Date = new Date();
  public anyoAnterior: Date = new Date();
  public loading;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(  private liquidacionCapturaService: LiquidacionCapturaService,
                private obrasService: ObrasService,
                private helperService: HelpersService,
    ) {
    this.meses = "Meses-Enero-Febrero-Marzo-Abril-Mayo-Junio-Julio-Agosto-Septiembre-Octubre-Noviembre-Diciembre";
    this.desdeMovimientos = false;
  }

  ngOnInit() {
    this.getObras();
    this.getFechaActual();
  }
  getObras(){
    this.obrasService.getObratoSelect(this.liquidacionCapturaService.modulo_url).subscribe((response)=>{
      this.obraFilterOptions = response.json().content;
      console.log("opciones de obra",this.obraFilterOptions);
    });
  }

  getFechaActual() {
    console.log('traerme fecha');
    this.liquidacionCapturaService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fechaActual = content.fecha;
          this.fechaLiquidacion = content.fecha_inicio;
          this.nuevoMes = content.fecha_inicio.split("-")[0]+"-"+content.fecha_inicio.split("-")[1];
          //this.getMes(this.fechaActual);

        }, (error) => {
          console.log('error en fecha ', error);
          // se revisan errores 403 - 500
          //this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  reset() {
    this.obraFilter = {};
  }

  close(){
    $('#liquidaciones-modal').modal('hide');
  }

  open() {
    this.reset();
    $('#liquidaciones-modal').modal('show');
  }


  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  changeObraSelected(obraSelected) {
    this.obraFilter = obraSelected;
  }

  accept() {
    console.log("obras",this.obraFilter.length);
    if(this.obraFilter.length < 1){
      this.helperService.notification('ERROR', 'Por favor, seleccione una obra.', 'error');
    }
   this.liquidacionCapturaService.createLiquidaciones(this.obraFilter.idObras,this.nuevoMes+"-01",this.desdeMovimientos)
        .subscribe(response => {
          if (response.json().success) {
            this.helperService.notification('Liquidación guardada', 'Se ha creado exitosamente la liquidación de la obra: ' + this.obraFilter.nombreObra + ' del mes de ' + this.nuevoMes, 'success');
            this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list
            this.close();
          }
        }, error => {
          this.close();
          if (error.status == 400) {
            // usamos modal en vez de notification
            this.errorModal.open({
              'title': 'ERROR',
              'description': 'La liquidación ya se encuentra registrada'
            });
          } else {
            // usamos modal en vez de notification
            this.errorModal.open({
              'title': 'ERROR',
              'description': 'No se pudo completar la acción solicitada. Por favor, intente más tarde.'
            });
          }
        });
  }


  setBackendErrors(errors:any[]){
    let temp_errors = [];

    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/liquidaciones-modal/liquidaciones-modal.component.ts